// extracted by mini-css-extract-plugin
module.exports = {"navlink":"NavContainer_navlink__jRO7Y","overflow":"NavContainer_overflow__VG4eZ","navlinkMotion":"NavContainer_navlinkMotion__5Rosc"};